// extracted by mini-css-extract-plugin
export default {"form":"NovoCliente_form__tXjxQ","areaBtn":"NovoCliente_areaBtn__UwBsj","btn":"NovoCliente_btn__9EhCe"};